import React, { useState, useRef, useEffect } from 'react';
import { RiArrowDropDownFill } from 'react-icons/ri';
import './CustomDropdown.css';

const CustomDropdown = ({ label, name, options, value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const handleSelect = (optionValue) => {
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
  };

  // Show label of selected option or placeholder if value is empty or not found
  const selectedLabel = options.find(opt => opt.value === value)?.label || placeholder;

  return (
    <div className="custom-dropdown-container" ref={dropdownRef}>
      <label htmlFor={name}>{label}</label>
      <div
        id={name}
        className="custom-dropdown-button"
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && setIsOpen(!isOpen)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        {selectedLabel}
        <RiArrowDropDownFill size={24} className="dropdown-icon" />
      </div>

      {isOpen && (
        <ul className="custom-dropdown-list" role="listbox" aria-labelledby={name}>
          {options.map((option, index) => (
            <li
              key={index}
              role="option"
              aria-selected={option.value === value}
              onClick={() => handleSelect(option.value)}
              className={option.value === value ? "selected-option" : ""}
              style={{ cursor: "pointer" }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
